var _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXls = function SvgXls(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEEEF",
    d: "M6 0c-.825 0-1.5.675-1.5 1.5v21c0 .825.675 1.5 1.5 1.5h15c.825 0 1.5-.675 1.5-1.5V6l-6-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B7BD",
    d: "M18 6h4.5l-6-6v4.5c0 .825.675 1.5 1.5 1.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M22.5 10.5 18 6h4.5zM4.5 13h13.6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 9,
    x: 2.1,
    y: 11,
    fill: "#C91E08",
    rx: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m6.248 13.5.806 1.363h.031l.811-1.363h.955l-1.22 2 1.247 2h-.972l-.82-1.365h-.032l-.82 1.365h-.969l1.252-2-1.228-2zm3.303 4v-4h.846v3.303h1.715v.697zm5.456-2.85a.5.5 0 0 0-.201-.367q-.178-.13-.483-.13a.9.9 0 0 0-.35.058.5.5 0 0 0-.218.158.4.4 0 0 0-.074.23.33.33 0 0 0 .045.188q.05.08.138.139.089.055.203.1.116.04.246.07l.36.086q.261.058.48.156.219.097.38.24.16.143.247.336.09.194.092.443a1.1 1.1 0 0 1-.187.637 1.2 1.2 0 0 1-.532.416q-.345.147-.834.147a2.2 2.2 0 0 1-.844-.149 1.24 1.24 0 0 1-.558-.44 1.3 1.3 0 0 1-.209-.724h.818q.015.201.116.336a.64.64 0 0 0 .275.201q.174.067.393.067.214 0 .373-.063.16-.062.248-.174a.4.4 0 0 0 .088-.256.33.33 0 0 0-.08-.226.6.6 0 0 0-.231-.156 2.3 2.3 0 0 0-.37-.118l-.435-.109q-.505-.123-.799-.385-.293-.262-.29-.705a1.05 1.05 0 0 1 .193-.635q.197-.27.54-.423.345-.153.782-.153.446 0 .777.153.334.152.52.423.185.271.191.63z"
  })));
};
export default SvgXls;